import * as z from "zod/v4";

export const postLinearComment = {
  name: "postLinearComment" as const,
  input: z.object({
    linearTicketId: z.string(),
    body: z.string(),
    avatarUrl: z.string().optional(),
  }),
  output: z.object({ success: z.boolean() }),
};
